export const ENDPOINTS = {
  USER_DOCUMENTS: (userId: string) =>
    `/api/document-processor/v1/user_documents?user_id=${userId}`,

  FILE_DOWNLOAD: (fileId: string) =>
    `/api/document-processor/v1/download?doc_id=${fileId}`,

  FILE_DELETE: "/api/document-processor/v1/file/delete",

  FILE_UPLOAD: "/api/document-processor/v1/upload",

  SEND_MAIL: "/api/document-processor/v1/mail",

  USER_QUERIES: (userId: string) =>
    `/api/document-processor/v1/rewrite/user_details?user_id=${userId}`,

  DELETE_EDITED_EMBEDDINGS:
    "/api/document-processor/v1/delete/editedembeddings",

  EDIT_RESPONSE: "/api/document-processor/v1/edit/response",
};

export const API_BASE_URL = process.env.REACT_APP_API_GATEWAY_URL;
